import React from 'react';
import PropTypes from 'prop-types';
import Box from 'common/components/Box';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Container from 'common/components/UI/Container';
import { CloudPouchWrapper, ContentWrapper, BookImage } from './cloudpouch.style';

const CloudPouch = ({
  sectionWrapper,
  row,
  col,
  title,
  description,
  secondDescription,
  textArea,
  imageArea,
}) => {
  return (
    <CloudPouchWrapper id="book_section">
      <Container>
        <Box {...sectionWrapper}>
          <Box {...row}>
            <Box {...col} {...imageArea}>
              <BookImage
                src="/CloudPouchInBook.jpg"
                alt="CloudPouch featured in the book Efficient Cloud FinOps, page 44"
                loading="lazy"
              />
            </Box>
            <Box {...col} {...textArea}>
              <ContentWrapper>
                <Heading
                  {...title}
                  content="Featured in the “Efficient Cloud FinOps” book"
                />
                <Text
                  {...description}
                  content={
                    <>
                      CloudPouch is described in{' '}
                      <a
                        href="https://www.oreilly.com/library/view/efficient-cloud-finops/9781805122579/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Efficient Cloud FinOps
                      </a>{' '}
                      (Packt Publishing) by Alfonso San Miguel Sánchez and
                      Danny Obando García. The authors present it as one of the
                      interesting FinOps tools — covering its cost breakdown,
                      Cost Insights, and the local, desktop-first model that
                      works with your AWS CLI and SSO profiles.
                    </>
                  }
                />
                <Text
                  {...secondDescription}
                  content="Independent authors writing about FinOps chose CloudPouch as a tool worth knowing. We think that says more than any ad could."
                />
              </ContentWrapper>
            </Box>
          </Box>
        </Box>
      </Container>
    </CloudPouchWrapper>
  );
};

CloudPouch.propTypes = {
  sectionWrapper: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
  secondDescription: PropTypes.object,
  textArea: PropTypes.object,
  imageArea: PropTypes.object,
};

CloudPouch.defaultProps = {
  sectionWrapper: {
    as: 'section',
    pt: ['40px', '80px'],
    pb: ['40px', '80px'],
  },
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center',
  },
  imageArea: {
    width: ['100%', '100%', '50%'],
    flexBox: true,
    mb: ['60px', null, null, 0],
  },
  textArea: {
    width: ['100%', '100%', '50%'],
  },
  col: {
    pr: '15px',
    pl: '15px',
  },
  title: {
    fontSize: ['26px', '32px', '36px', '40px'],
    fontWeight: '700',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '20px',
    lineHeight: '1.25',
  },
  description: {
    fontSize: ['15px', '15px', '16px', '16px'],
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '20px',
  },
  secondDescription: {
    fontSize: ['15px', '15px', '16px', '16px'],
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '0',
  },
};

export default CloudPouch;
